import { SectorGeometry } from '../models/sector.model'

/**
 * Teste si un point (latitude, longitude) est à l'intérieur d'un polygone GeoJSON.
 * Algorithme ray-casting. Gère l'anneau extérieur (les trous éventuels sont ignorés,
 * un secteur étant un polygone plein).
 *
 * Rappel : en GeoJSON, les coordonnées sont au format [longitude, latitude].
 */
export function isPointInSector(
  latitude: number,
  longitude: number,
  geometry: SectorGeometry | null | undefined
): boolean {
  if (!geometry?.coordinates?.length) return false

  // Anneau extérieur uniquement
  const ring = geometry.coordinates[0]
  if (!ring || ring.length < 3) return false

  let inside = false
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const xi = ring[i][0] // longitude
    const yi = ring[i][1] // latitude
    const xj = ring[j][0]
    const yj = ring[j][1]

    const intersects =
      yi > latitude !== yj > latitude &&
      longitude < ((xj - xi) * (latitude - yi)) / (yj - yi) + xi
    if (intersects) inside = !inside
  }

  return inside
}

/**
 * Calcule l'emprise [[south, west], [north, east]] d'un secteur,
 * directement utilisable par Leaflet (fitBounds). Renvoie null si vide.
 */
export function getSectorBounds(
  geometry: SectorGeometry | null | undefined
): [[number, number], [number, number]] | null {
  const ring = geometry?.coordinates?.[0]
  if (!ring || ring.length === 0) return null

  let minLat = Infinity
  let maxLat = -Infinity
  let minLng = Infinity
  let maxLng = -Infinity

  for (const [lng, lat] of ring) {
    if (lat < minLat) minLat = lat
    if (lat > maxLat) maxLat = lat
    if (lng < minLng) minLng = lng
    if (lng > maxLng) maxLng = lng
  }

  return [
    [minLat, minLng],
    [maxLat, maxLng],
  ]
}
